import {
  CREATE_SCRIBE_FROM_TEMPLATE,
  CREATE_SCRIBE_FROM_TEMPLATE_SUCCESS,
  CREATE_SCRIBE_FROM_TEMPLATE_FAILED,
  GET_SCRIBE_TEMPLATES,
  GET_SCRIBE_TEMPLATES_FAILED,
  GET_SCRIBE_TEMPLATES_BY_CATEGORY_SUCCESS,
  SAVE_SCRIBE_AS_TEMPLATE,
  SAVE_SCRIBE_AS_TEMPLATE_SUCCESS,
  SAVE_SCRIBE_AS_TEMPLATE_FAILED,
  CONTENTFUL_OAUTH_SUCCESS,
  CONTENTFUL_OAUTH_INVALID,
  CONTENTFUL_OAUTH_LOADED
} from '../actionCreators/templatesActions';

export const STATUS_SAVING = 'STATUS_SAVING';
export const STATUS_CLONING = 'STATUS_CLONING';
export const STATUS_INACTIVE = 'STATUS_INACTIVE';

const initialState = {
  saveStatus: STATUS_INACTIVE,
  error: null,
  contentfulManagementToken: null,
  templatesByCategory: [],
  isFetchingTemplates: true
};

export default function templatesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SCRIBE_TEMPLATES_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        templatesByCategory: action.categories,
        isFetchingTemplates: false
      };

    case CREATE_SCRIBE_FROM_TEMPLATE:
      return {
        ...state,
        saveStatus: STATUS_CLONING
      };

    case SAVE_SCRIBE_AS_TEMPLATE:
      return {
        ...state,
        saveStatus: STATUS_SAVING
      };

    case SAVE_SCRIBE_AS_TEMPLATE_SUCCESS:
    case SAVE_SCRIBE_AS_TEMPLATE_FAILED:
    case CREATE_SCRIBE_FROM_TEMPLATE_SUCCESS:
    case CREATE_SCRIBE_FROM_TEMPLATE_FAILED:
      return {
        ...state,
        saveStatus: STATUS_INACTIVE
      };

    case CONTENTFUL_OAUTH_SUCCESS:
    case CONTENTFUL_OAUTH_LOADED:
      return {
        ...state,
        contentfulManagementToken: action.payload
      };

    case CONTENTFUL_OAUTH_INVALID:
      return {
        ...state,
        contentfulManagementToken: null
      };

    case GET_SCRIBE_TEMPLATES: {
      return {
        ...state,
        isFetchingTemplates: true
      };
    }

    case GET_SCRIBE_TEMPLATES_FAILED: {
      return {
        ...state,
        isFetchingTemplates: false
      };
    }

    default:
      return state;
  }
}
